const es = {
    '例子': 'Ejemplo',
}
export default es;